import { createContext, useEffect, useState } from "react";
import { axiosPublic } from "../Utils/axios";

export const CodeContext = createContext()

export const CodeContextProvider = ({ children }) => {
    const [ code, setCode ] = useState({});
    useEffect(() => {
        const controller = new AbortController()
        async function getCodes() {
            try {
                 await axiosPublic.get("getCodes", { headers: { signal: controller.signal } })
                    .then((response) => {
                        if (response.data.success) {
                            let data = response.data.data
                            let newObject ={}
                            data.map((item) => {
                                newObject[item.abb] = item.code
                            })
                            setCode(newObject)
                            
                        } else {
                            console.error("Error:",response.data)
                        }
                    })
                
            } catch (error) {
                console.error('Get Code Error:', error.message)
            }
        }
        getCodes()
        return (() => {
            return controller.abort()
        })
    }, []);

    return (
        <CodeContext.Provider value={{code}}>
            {children}
        </CodeContext.Provider>
    )
}